import{isDateConstructorArg as e}from"./envTypes.js";function r(r,n){if(r.length)return r.reduce(((r,o)=>{const t=r[n],c=o[n];if(!e(t)||!e(c))throw new Error(`Key: "${n}" cannot be used for chronological sorting`);return new Date(t)<new Date(c)?o:r}))}export{r as findLatestByKey};
//# sourceMappingURL=array.js.map
